<template>

<section class="search">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <h2>
                    Behind every Fan Review is <br>
                    a personal experience that matters 
                </h2>
                <p> Find models, Read Reviews. Find Reviews </p>
            </div>
        </div>

        <div class="row d-flex justify-content-center">
            <div class="col-lg-5 col-md-6 col-sm-8">                   
                <search-form></search-form>               
            </div>
        </div>   
    </div>
</section>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

        }

    }
</script>
